export const primary = "#7B7DE5";
export const secondary = "#F5F5FF";

export const textPrimary = "#202020";
export const textsecondary = "#2D2D2D8C";
export const textLight = "#888888";

export const lightBg = "#F5F5FF";
export const lightBg2 = "#F1F2FF";

export const darkBg = "#1a1a1a";
export const darkerBg = "#0f0f0f";
export const gradientBg =
  "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%)";
